/* eslint-disable no-underscore-dangle, class-methods-use-this */

'use strict';

define('vb/private/stateManagement/router/vbPathMarkerRootRouter',[
  'vb/private/stateManagement/router/vbRouter',
  'vb/private/stateManagement/router/vbRootRouter',
  'vb/private/configuration',
], (VbRouter, VbRootRouter, Configuration) => {
  /**
   * A root router for application using the path strategy but no "appName" in the URL.
   * A URL marker "vp" is place in the URL to mark the beginning of part of the URL representing
   * the state of the router in the URL.
   * The "vp" is in the URL is done using a place holder child router with state value of "vp".
   */
  class VbPathMarkerRootRouter extends VbRouter {
    constructor() {
      const topRootRouter = new VbRootRouter();

      // When using the path strategy and the appName is not defined, we need to introduce a marker in the URL.
      // The urlMarker is 'vp', the value of Configuration.urlMarker
      topRootRouter.configure({
        [Configuration.urlMarker]: {
          isDefault: true,
        },
      });

      super(Configuration.urlMarker, topRootRouter, Configuration.urlMarker);

      // Makes it a child router of the root router
      topRootRouter._childRouters.push(this);
    }

    /**
     * overrides go
     * Wrap the go method when the URL marker 'vp' is needed.
     */
    go(...args) {
      const argsCopy = [...args];

      // When using the 'path strategy', prefixes the path with /vp
      argsCopy[0] = `/${Configuration.urlMarker}/${argsCopy[0]}`;

      return super.go(...argsCopy);
    }

    /**
     * Delegate to the root router
     */
    updateState(pagePath, replace) {
      return VbRouter.rootInstance.updateState(pagePath, replace);
    }

    /**
     * Delegate to the root router
     */
    setCurrentNavPath(navPath) {
      VbRouter.rootInstance.setCurrentNavPath(navPath);
    }

    /**
     * Delegate to the root router
     */
    getCurrentNavPath() {
      return VbRouter.rootInstance.getCurrentNavPath();
    }

    dispose() {
      super.dispose();
      VbRouter.rootInstance.dispose();
    }
  }

  return VbPathMarkerRootRouter;
});

